import { DifferentValue, LinkValue, SameValue, UnLinkValue } from '../../assets'

export const MASTER_CATEGORY = 'MasterCategory'
export const MASTER_PRODUCT = 'MasterProduct'

export const updateChildSource = (type, props, field, source) => {
  const {
    node: { gridApi },
    data,
  } = props
  gridApi.forEachNode((node) => {
    if (node.data) {
      var masterId = type == MASTER_CATEGORY ? data.parentCategoryId : data.masterId
      var nodeChildren = type == MASTER_CATEGORY ? node.data.childCategories : node.data.children

      if (node.data.id == masterId) {
        const newChildren = (nodeChildren || []).map((child) => {
          if (child.id == data.id) {
            child[field] = data[field]
            child.sourceMap = {
              ...child.sourceMap,
              archived:
                field == 'active' && type == MASTER_CATEGORY ? false : child.sourceMap.archived,
              [field]: source,
            }
          }
          return child
        })
        node.setData({
          ...node.data,
          children: newChildren,
        })
      }
      if (node.data.id == data.id) {
        node.setData({
          ...node.data,
          sourceMap: {
            ...node.data.sourceMap,
            [field]: source,
          },
        })
      }
    }
  })
}

export const handleIcon = (type, props, icon, field) => {
  switch (icon) {
    case DifferentValue:
      handleDifferentValue(type, props, field)
      break
    case UnLinkValue:
      handleUnlinkValue(type, props, field)
      break
  }
}

const handleDifferentValue = (type, props, field) => {
  const {
    node: { gridApi },
    data,
  } = props
  gridApi.forEachNode((node) => {
    if (node.data) {
      var childrenField = type == MASTER_CATEGORY ? 'childCategories' : 'children'
      var nodeMasterId = type == MASTER_CATEGORY ? node.data.parentCategoryId : node.data.masterId
      var nodeChildren = type == MASTER_CATEGORY ? data[childrenField] : data[childrenField]
      nodeChildren = (nodeChildren || []).map((item) => {
        return {
          ...item,
          masterId: type == MASTER_CATEGORY ? item.parentCategoryId : item.masterId,
        }
      })

      if (nodeMasterId == data.id) {
        node.setData({
          ...node.data,
          [field]: data[field],
          sourceMap: {
            ...node.data.sourceMap,
            [field]: 'PARENT',
          },
        })
      }
      if (node.data.id == data.id) {
        const children = nodeChildren.map((child) => {
          if (child.masterId == data.id) {
            child[field] = data[field]
            child.sourceMap = {
              ...child.sourceMap,
              [field]: 'PARENT',
            }
          }
          return child
        })
        node.setData({
          ...node.data,
          [childrenField]: children,
        })
      }
    }
  })
}

const handleUnlinkValue = (type, props, field) => {
  const { setValue } = props
  setValue(getParentValue(type, props, field))
  updateChildSource(type, props, field, 'PARENT')
}

export const getParentValue = (type, props, field) => {
  const {
    node: { gridApi },
    data,
  } = props
  let value
  gridApi.forEachNode((node) => {
    if (node.data) {
      var nodeMasterId = type == MASTER_CATEGORY ? data.parentCategoryId : data.masterId
      if (nodeMasterId == node.data.id) {
        value = node.data[field]
      }
    }
  })

  switch (field) {
    case 'photo':
      return value.thumbURL
    case 'active':
      return type == MASTER_CATEGORY ? (value ? 'active' : 'inactive') : value
    case 'archived':
      return type == MASTER_CATEGORY ? (value ? '' : data.active ? 'active' : 'inactive') : value
    default:
      return value
  }
}

export const getLinkIcon = (type, isParent, data, field) => {
  var icon = SameValue
  var title = ''

  var children = data.children
  children =
    children &&
    children.map((item) => {
      return {
        ...item,
        masterId: type === MASTER_CATEGORY ? data.parentCategoryId : data.masterId,
      }
    })
  var masterId = type === MASTER_CATEGORY ? data.parentCategoryId : data.masterId

  if (children || masterId) {
    if (isParent) {
      let validation = validateControlByParent(children || [], field)
      icon = validation ? SameValue : DifferentValue
      title = validation ? 'Synced' : 'Unsynced'
    } else {
      icon = data.sourceMap[field] === 'PARENT' ? LinkValue : UnLinkValue
      title = data.sourceMap[field] === 'PARENT' ? 'Linked' : 'Unlinked'
    }
  }

  return {
    icon,
    title,
  }
}

const validateControlByParent = (children, field) => {
  let validation = true
  children.forEach((child) => {
    if (child.sourceMap && child.sourceMap[field] != 'PARENT') {
      validation = false
    }

    if (field == 'active' && child.sourceMap && child.sourceMap['archived'] == 'CHILD') {
      validation = false
    }
  })
  return validation
}

export const updateChildValues = (type, props, field, value) => {
  const {
    node: { gridApi },
    data,
  } = props
  gridApi.forEachNode((node) => {
    if (node.data) {
      var nodeMasterId = type == MASTER_CATEGORY ? node.data.parentCategoryId : node.data.masterId
      var nodeChildren = type == MASTER_CATEGORY ? node.data.childCategories : node.data.children

      if (nodeMasterId == data.id && node.data.sourceMap[field] === 'PARENT') {
        node.setData({
          ...node.data,
          [field]: value,
        })
      }
      if (node.data.id == data.id) {
        const children = nodeChildren.map((child) => {
          if (child.sourceMap[field] == 'PARENT') {
            child[field] = value
          }
          return child
        })

        node.setData({
          ...node.data,
          children,
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/CommonUpdateCells.js